import Cookies from "js-cookie";
import { DEV_MODE_COOKIES, dev_cookie_name } from "@core/helpers/dev-mode-rules";

// storefront dev mode: the login and cart cookies are the replica's own while `_dev_mode` is set (dev-mode-rules.js)
const named = (name) => dev_cookie_name(name, Boolean(Cookies.get(DEV_MODE_COOKIES.token)));

export const get_all_cookies_client = () => {
  var pairs = document.cookie.split(";");
  var cookies = {};
  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i].split("=");
    cookies[(pair[0] + "").trim()] = unescape(pair.slice(1).join("="));
  }
  return cookies;
};

export const has_cookie_client = (name = "") => {
  const cookies = get_all_cookies_client();
  return !!cookies?.[named(name)];
};

export const get_cookie_client = (name = "") => {
  return Cookies.get(named(name));
};

export const set_cookie_client = (name = "", value, options = {}) => {
  if (!options?.expires) {
    options = { ...options, expires: 30 };
  }

  if (!options?.path) {
    options = { ...options, path: '/' };
  }
  
  return Cookies.set(named(name), value, options);
};

export const remove_cookie_client = (name = "") => {
  return Cookies.remove(named(name), { path: "" });
};
